import AvailableEvents from "components/_Pages/MySpace/Events";
import BannerInfo from "./BannerInfo";

interface IBannerWidgetPropsProps {
  clean?: boolean;
  variant: "info" | "events";
}

export default function BannerWidget(props: IBannerWidgetPropsProps) {
  return (
    <>
      {props.variant === "info" && <BannerInfo clean={props.clean} />}
      {props.variant === "events" && <AvailableEvents />}
    </>
  );
}
